import React, {useEffect, useState} from "react";
import {Box, Grid, Typography} from "@mui/material";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {makeStyles} from "@mui/styles";
import clsx from "clsx";

import RoundList from "../../components/RoundList";
import BoxNumber from "./Components/BoxNumber";
import RoundCreator from "./Components/RoundCreator";
import LineGenerator from "./Components/LineGenerator";

import {colors} from "../../utils/colors";
import {StyledMatchGrid} from "./styles";
import {ManualDeclareWinner} from "./ManualDeclareWinner";

export const useStyles = makeStyles({
    box: {
        display: "flex",
        height: "80px",
        marginTop: "8px",
        position: "relative",
    },
    mainBox: {
        padding: "8px",
        width: "85%",
        borderRadius: "0px 8px 8px 0px",
        color: "#fff",
        cursor: "pointer",
    },
    blackNumBox: {
        backgroundColor: "#000",
        color: "#fff",
        width: 30,
        minWidth: 30,
        borderRadius: "8px 0px 0px 8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    greyBox: {
        backgroundColor: "#D3D3D3",
        zIndex: 1,
    },
    greenBox: {
        backgroundColor: colors.PRIMARY,
        zIndex: 1,
    },
    alignBoxes: {
        position: "relative",
        display: "flex",
        flexDirection: "column !important",
        justifyContent: "space-around",
    },
    playerName: {
        fontWeight: "bold !important",
        wordWrap: "break-word",
    },
});

const PlayerList = ({list, no_of_teams, leagueId}) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dmp_list = useSelector((state) => state.getSelectedDMPLeagueReducer);

    const [leagueData, setLeagueData] = useState([]);

    const handleClick = (val, league_id, _id) => {
        if (
            val.group1 == null ||
            val.group2 == null ||
            val.group1.length <= 1 ||
            val.group2.length <= 1
        ) {
            return null;
        } else {
            navigate(`/dmp/scorecard/${val._id}`, {state: {league_id, _id}});
        }
    };

    useEffect(() => {
        if (
            dmp_list?.data !== undefined &&
            dmp_list?.data?.message !== "Records not found"
        ) {
            if (Object.keys(dmp_list?.data).length > 0) {
                setLeagueData(dmp_list?.data?.leageData);
            }
        }
    }, [dmp_list]);

    return (
        <Grid
            sx={{overflow: "hidden", overflowX: "auto"}}
            container
            spacing={2}
            alignItems="center"
        >
            <Grid
                item
                container
                xs={12}
                spacing={2}
                sx={{flexWrap: "nowrap", mt: 2}}
            >
                {dmp_list?.data?.leageData && (
                    <>
                        {list.map((roundItem, index) => (
                            <Grid
                                key={roundItem.label}
                                item
                                xs={3}
                                xl={2}
                                sx={{minWidth: "230px"}}
                            >
                                <RoundList
                                    number={no_of_teams}
                                    roundItem={roundItem}
                                    index={index}
                                />
                            </Grid>
                        ))}
                    </>
                )}
            </Grid>

            <Grid
                item
                container
                xs={12}
                spacing={2}
                sx={{flexWrap: "nowrap", mb: 2}}
            >
                {dmp_list?.data?.leageData &&
                    leagueData.length > 0 &&
                    leagueData[0]?.rounds?.map((round, mainIndex) => {
                        const {matches, league_id, _id} = round;
                        return (
                            <StyledMatchGrid item xs={3} xl={2}>
                                {matches.map((item, idx) => {
                                    const {won, score_up_value} = item;
                                    let winningGroup = won !== undefined ? won : "";

                                    if (item.virtual !== undefined && item.virtual) {
                                        return (
                                            <Box className={classes.box}>
                                                <BoxNumber virtual/>
                                                <Box
                                                    className={clsx(classes.mainBox, classes.greenBox)}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        className={classes.playerName}
                                                    >
                                                        {item["group1"][0].name} (
                                                        {item["group1"][0].playing_handicap})
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        className={classes.playerName}
                                                    >
                                                        {item["group1"][1].name} (
                                                        {item["group1"][1].playing_handicap})
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        className={classes.playerName}
                                                        sx={{
                                                            marginTop: "10px",
                                                            letterSpacing: "2px",
                                                        }}
                                                    >
                                                        {item.isWinner && <>{item.autoScoreHoles}</>}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        );
                                    } else {
                                        return ["group1", "group2"].map((group, index) => {
                                            return (
                                                <Box key={index}>
                                                    <Box className={classes.box}>
                                                        <BoxNumber childIndex={index} parentIndex={idx}/>
                                                        <Box
                                                            sx={{
                                                                background:
                                                                    (index % 2 == 0 &&
                                                                        item.is_bye != null &&
                                                                        item.is_bye == "group2") ||
                                                                    (index % 2 == 1 &&
                                                                        item.is_bye != null &&
                                                                        item.is_bye == "group1")
                                                                        ? "#06623B"
                                                                        : "",
                                                            }}
                                                            className={clsx(
                                                                classes.mainBox,
                                                                winningGroup === group
                                                                    ? classes.greenBox
                                                                    : classes.greyBox
                                                            )}
                                                        >
                                                            {mainIndex !== 0 && item.isWinner == null && <Box sx={{position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)'}}>
                                                                <ManualDeclareWinner round={round} roundsList={list} group={group} item={item} />
                                                            </Box>}

                                                            <Box onClick={() => handleClick(item, league_id, _id)}>
                                                                <Typography
                                                                    variant="body2"
                                                                    className={classes.playerName}
                                                                >
                                                                    {item[group] === null ||
                                                                    item[group] === undefined
                                                                        ? "TBA"
                                                                        : mainIndex !== 0 && item[group].length === 0
                                                                            ? "TBA"
                                                                            : mainIndex === 0 && item[group].length === 0
                                                                                ? "BYE"
                                                                                : item[group][0]?.name}
                                                                    {item[group] === null ||
                                                                    item[group] === undefined ||
                                                                    item[group][0]?.playing_handicap == undefined
                                                                        ? ""
                                                                        : item[group].length === 0
                                                                            ? ""
                                                                            : ` (${item[group][0]?.playing_handicap})`}
                                                                </Typography>
                                                                <Typography
                                                                    variant="body2"
                                                                    className={classes.playerName}
                                                                >
                                                                    {item[group] === null ||
                                                                    item[group] === undefined
                                                                        ? "TBA"
                                                                        : mainIndex !== 0 && item[group].length === 0
                                                                            ? "TBA"
                                                                            : mainIndex === 0 && item[group].length === 0
                                                                                ? "BYE"
                                                                                : item[group][1]?.name}
                                                                    {item[group] === null ||
                                                                    item[group] === undefined ||
                                                                    item[group][1]?.playing_handicap == undefined
                                                                        ? ""
                                                                        : item[group].length === 0
                                                                            ? ""
                                                                            : ` (${item[group][1]?.playing_handicap})`}
                                                                </Typography>

                                                                {item.is_bye && item.is_bye !== group && (
                                                                    <>
                                                                        <Typography
                                                                            variant="body2"
                                                                            className={classes.playerName}
                                                                            sx={{
                                                                                marginTop: "10px",
                                                                            }}
                                                                        >
                                                                            Won in BYE
                                                                        </Typography>
                                                                    </>
                                                                )}

                                                                {winningGroup !== "" &&
                                                                    winningGroup === group && (
                                                                        <Typography
                                                                            variant="body2"
                                                                            className={classes.playerName}
                                                                            sx={{
                                                                                marginTop: "10px",
                                                                            }}
                                                                        >
                                                                            {score_up_value === "SD"
                                                                                ? "Won In Play Off"
                                                                                : item.autoScoreHoles !== undefined
                                                                                    ? item.autoScoreHoles
                                                                                    : item?.score_up_value}
                                                                        </Typography>
                                                                    )}
                                                            </Box>
                                                        </Box>

                                                        <LineGenerator
                                                            index={index}
                                                            roundsList={list}
                                                            matches={matches}
                                                        />
                                                    </Box>
                                                </Box>
                                            );
                                        });
                                    }
                                })}
                            </StyledMatchGrid>
                        );
                    })}

                <RoundCreator selectedList={dmp_list} roundsList={list}/>
            </Grid>
        </Grid>
    );
};

export default PlayerList;
